export function formatArtworkTitleForDisplay(title) {
  if (typeof title !== 'string') {
    return '';
  }

  let normalizedTitle = title.replace(/\s+/g, ' ').trim();
  if (!normalizedTitle) {
    return '';
  }

  normalizedTitle = normalizedTitle.replace(/^\.+\s*/, '').trim();
  if (!normalizedTitle) {
    return '';
  }

  const quotePairs = [
    ['"', '"'],
    ['“', '”'],
    ['«', '»'],
  ];

  const matchingQuotePair = quotePairs.find(([openingQuote, closingQuote]) => (
    normalizedTitle.startsWith(openingQuote) && normalizedTitle.endsWith(closingQuote)
  ));

  if (!matchingQuotePair) {
    return normalizedTitle;
  }

  const [openingQuote, closingQuote] = matchingQuotePair;
  const unwrappedTitle = normalizedTitle
    .slice(openingQuote.length, normalizedTitle.length - closingQuote.length)
    .trim();

  return unwrappedTitle || normalizedTitle;
}
